import { FOfferType, NonEmptyArray } from '../../../../../../../../../packages/JsonQuery';
import { useSelector } from 'react-redux';
import { useOfferTypeChangeHandler } from 'shared/hooks';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { FC, useCallback } from 'react';
import { selectOfferTypeFilter } from 'shared/selectors/filters';

export const RentDailyObjectTypeContainer: FC = () => {
  const { value, options } = useSelector(selectOfferTypeFilter);

  const onOfferTypeChange = useOfferTypeChangeHandler();

  const handleObjectTypeChange = useCallback(
    (nextValue: NonEmptyArray<FOfferType> | null) => {
      onOfferTypeChange(nextValue ?? /* istanbul ignore next */ []);
    },
    [onOfferTypeChange],
  );

  return (
    <AdvancedFilterRow label="Тип объекта">
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleObjectTypeChange} />
    </AdvancedFilterRow>
  );
};
